import type { HTMLAttributes, ReactNode } from "react"

import { cn } from "~/v2/utils/cn"

type CardPartProps<T extends HTMLElement> = HTMLAttributes<T> & {
  children?: ReactNode
  className?: string
}

export const Card = ({
  children,
  className,
  ...props
}: CardPartProps<HTMLElement>) => {
  return (
    <section
      className={cn(
        "rounded-xl border border-border bg-card text-card-foreground shadow-sm",
        className,
      )}
      {...props}
    >
      {children}
    </section>
  )
}

export const CardHeader = ({
  children,
  className,
  ...props
}: CardPartProps<HTMLDivElement>) => {
  return (
    <div className={cn("flex flex-col gap-2 p-6", className)} {...props}>
      {children}
    </div>
  )
}

export const CardTitle = ({
  children,
  className,
  ...props
}: CardPartProps<HTMLHeadingElement>) => {
  return (
    <h2
      className={cn("text-xl font-semibold text-foreground", className)}
      {...props}
    >
      {children}
    </h2>
  )
}

export const CardDescription = ({
  children,
  className,
  ...props
}: CardPartProps<HTMLParagraphElement>) => {
  return (
    <p className={cn("text-sm text-muted-foreground", className)} {...props}>
      {children}
    </p>
  )
}

export const CardContent = ({
  children,
  className,
  ...props
}: CardPartProps<HTMLDivElement>) => {
  return (
    <div className={cn("p-6 pt-0", className)} {...props}>
      {children}
    </div>
  )
}
